import 'devextreme/dist/css/dx.light.css';
import { ReactNode, useState, useEffect } from 'react';
import { Links } from '../../data/data';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import * as C from './styles';

import { NavLink } from 'react-router-dom';
import { useMenu } from '../../hooks/useMenu';
import api from '../../services/api';
import { SelectBox } from 'devextreme-react';
import { Popup } from 'devextreme-react/popup';

type Props = {
  children: ReactNode;
};

interface ISafra {
  haverst: string;
}

export const Theme = ({ children }: Props) => {
  const { open } = useMenu();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [safras, setSafras] = useState<ISafra[]>([]);
  const [selectedSafra, setSelectedSafra] = useState<string | null>(null);
  const [selectedCultureType, setSelectedCultureType] = useState<string | null>(null);
  const [isLoadingSafras, setIsLoadingSafras] = useState(false);
  const [typeList, setTypeList] = useState<string | null>(null);

  const cultureTypes = [
    { value: 'MILHO', label: 'Milho' },
    { value: 'SORGO', label: 'Sorgo' },
  ];

  useEffect(() => {
    if (isModalVisible) {
      loadSafras();
    }
  }, [isModalVisible]);

  const loadSafras = async () => {
    try {
      setIsLoadingSafras(true);
      const response = await api.get('/admin/safras');
      setSafras(response.data);
    } catch (error) {
      console.error('Erro ao carregar safras:', error);
    } finally {
      setIsLoadingSafras(false);
    }
  };

  const handleExport = (typeList: string) => {
    setIsModalVisible(true);
    setSelectedSafra(null);
    setSelectedCultureType(null);
    setTypeList(typeList);
  };


  const handleExportSubscriptionStream = async () => {
    try {
      setIsModalVisible(false);
      const response = await api.post(
        '/admin/export-subscription-stream',
        {
          haverst: selectedSafra,
          culture_type: selectedCultureType,
        },
        {
          responseType: 'blob',
        }
      );

      // Criar link de download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'inscricoes.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  };

  const handleMinExport = async () => {
    try {
      const response = await api.post('/admin/export-min', {
        haverst: selectedSafra,
        culture_type: selectedCultureType,
      }, {
        responseType: 'blob',
        withCredentials: true,
      });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'inscricoes-min.xlsx'; // Nome do arquivo a ser baixado
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  };

  const handleListNutritionExport = async () => {
    try {
      const response = await api.post('/admin/export-nutritions', {
        haverst: selectedSafra,
        culture_type: selectedCultureType
      },
        {
          responseType: 'blob', // Indica que a resposta é um arquivo
          withCredentials: true,
        });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'nutricoes.xlsx'; // Nome do arquivo a ser baixado
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  };

  const handleListProtectionExport = async () => {
    try {
      const response = await api.post('/admin/export-protections', {
        haverst: selectedSafra,
        culture_type: selectedCultureType,
      }, {
        responseType: 'blob', // Indica que a resposta é um arquivo
        withCredentials: true,
      });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'protecoes.xlsx'; // Nome do arquivo a ser baixado
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedSafra(null);
    setSelectedCultureType(null);
    setTypeList(null);
  };

  const handleConfirmExport = async () => {
    if (!selectedSafra || !selectedCultureType || !typeList) {
      return;
    }

    switch (typeList) {
      case 'subscriptions':
        await handleExportSubscriptionStream();
        break;
      case 'min-subscriptions':
        await handleMinExport();
        break;
      case 'nutritions':
        await handleListNutritionExport();
        break;
      case 'protections':
        await handleListProtectionExport();
        break;
    };

    handleCloseModal()
  }

  return (
    <C.Container>
      <Header />
      <C.Area>
        <C.Steps>
          <C.Sidebar open={open}>
            <C.ContentLeft>
              <C.CheckSteps>
                {Links.map((item, index) => (
                  <C.BoxMenu key={index}>
                    <C.TitleSectionSidebar>{item.title}</C.TitleSectionSidebar>
                    {item.links.map((link, i) => (
                      <NavLink key={i} to={link.path}>
                        <C.LinNav>
                          {link.icon}&nbsp;{link.name}
                        </C.LinNav>
                      </NavLink>
                    ))}
                  </C.BoxMenu>
                ))}
                <C.BoxMenu>
                  <C.TitleSectionSidebar>Relatórios</C.TitleSectionSidebar>
                  <C.LinNav onClick={() => handleExport('min-subscriptions')}>
                    Exportar Resumo Dados
                  </C.LinNav>
                  <C.LinNav onClick={() => handleExport('subscriptions')}>Exportar Dados</C.LinNav>
                  <C.LinNav onClick={() => handleExport('nutritions')}>
                    Exportar Lista de Nutricões
                  </C.LinNav>
                  <C.LinNav onClick={() => handleExport('protections')}>
                    Exportar Lista de Protecões
                  </C.LinNav>
                </C.BoxMenu>
              </C.CheckSteps>
            </C.ContentLeft>
          </C.Sidebar>
          <C.Page>{children}</C.Page>
        </C.Steps>
      </C.Area>
      <Footer />

      <Popup
        title="Selecionar Safra e Cultura"
        visible={isModalVisible}
        hideOnOutsideClick={true}
        onHiding={handleCloseModal}
        width={400}
        height={400}
      >
        <C.ContentModal>
          <C.ContentModalInput>
            <SelectBox
              dataSource={safras}
              displayExpr="haverst"
              valueExpr="haverst"
              value={selectedSafra}
              onValueChanged={(e) => setSelectedSafra(e.value)}
              stylingMode="underlined"
              labelMode="static"
              label="Safra"
              placeholder="Selecione uma safra..."
              width="100%"
              height={50}
              disabled={isLoadingSafras}
              searchEnabled={true}
            />
            <SelectBox
              dataSource={cultureTypes}
              displayExpr="label"
              valueExpr="value"
              value={selectedCultureType}
              onValueChanged={(e) => setSelectedCultureType(e.value)}
              stylingMode="underlined"
              labelMode="static"
              label="Cultura"
              placeholder="Selecione uma cultura..."
              width="100%"
              height={50}
              disabled={isLoadingSafras}
            />
          </C.ContentModalInput>
          <C.BoxButtonSubmitModal>
            <button onClick={handleCloseModal}>Cancelar</button>
            <button
              onClick={handleConfirmExport}
              disabled={!selectedSafra || !selectedCultureType || isLoadingSafras}
            >
              Exportar
            </button>
          </C.BoxButtonSubmitModal>
        </C.ContentModal>
      </Popup>
    </C.Container>
  );
};
